import { FC } from 'react'
import { Wrapper, InstancesEmptyWrapper } from './EmptyState.styles'
import { Box, SxProps, Theme, Typography } from '@mui/material'
import ZeroState from '../../../components/svg/ZeroState'

interface Props {
  title?: string
  description?: string
  noBorder?: boolean
  variant?: 'default' | 'instances'
  sx?: SxProps<Theme>
}

const EmptyState: FC<Props> = ({ title, description, noBorder, variant = 'default', sx }) => {
  if (variant === 'instances') {
    return (
      <InstancesEmptyWrapper>
        <Box className="content">
          <ZeroState />
          <Typography className="title">{title || 'No Results Found'}</Typography>
          <Typography className="description">
            {description || 'Try changing the filter values, or select different sources'}
          </Typography>
        </Box>
      </InstancesEmptyWrapper>
    )
  }

  return (
    <Wrapper sx={{ border: noBorder ? 'none !important' : '', ...sx as object }}>
      <Box className="content">
        <ZeroState />
        <Typography className="title">{title || 'No Results Found'}</Typography>
        <Typography className="description">
          {description || 'Try changing the filter values, or select different sources'}
        </Typography>
      </Box>
    </Wrapper>
  )
}

export default EmptyState
